import {NgModule} from '@angular/core';
import {
  Routes,
  RouterModule
} from '@angular/router';

import {UsatiComponent} from './usati.component';
import {UsatiListaComponent} from './usati-lista.component';
import {UsatiService} from './services/usati.service';

const routes: Routes = [
  {path: '', component: UsatiListaComponent},
  {path: 'veicolo-usato/:id', component: UsatiComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [UsatiService]
})
export class UsatiRoutingModule {
}
